import React from 'react';
import ModuleLayout from '../../layouts/ModuleLayout';
import UomManagement from '../../components/Admin/Inventory/UnitsOfMeasurement';

/**
 * Units of Measurement Page
 * Manage UoM in Inventory module
 */
export default function UoMPage() {
  return (
    <ModuleLayout>
      <div className="flex flex-col h-full">
        {/* Header */}
        <div className="bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between sticky top-0 z-10">
          <h1 className="text-lg font-bold text-slate-900">Units of Measurement</h1>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          <UomManagement />
        </div>
      </div>
    </ModuleLayout>
  );
}
